export default __webpack_public_path__ + "media/images/images/banner/banner-18-e7582ba99fc716b14fb8078866d33519.jpg";